<template>
  <div class="hero is-fullheight" style="background-color: #fbfbfb;">
    <div class="hero-head">
      <top-navbar></top-navbar>
      <dashboard-content></dashboard-content>
    </div>
    <div class="hero-foot">
      <content-footer></content-footer>
    </div>
    <message-box></message-box>
  </div>
</template>

<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MessageBox from '../../components/MessageBox.vue'

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MessageBox
  },
  mounted() {
    document.querySelector('body').classList.add('has-navbar-fixed-top')
  }
}
</script>
